import React, { PureComponent } from 'react';
import Button from '../button/Button';
import { ButtonColor, FuncType } from '../button/enum';
export default class Pager extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { page, onClick } = this.props;
            if (onClick) {
                onClick(page);
            }
        };
    }
    render() {
        const { active, renderer, page, type, disabled, className } = this.props;
        return (React.createElement(Button, { className: className, funcType: active ? FuncType.raised : FuncType.flat, onClick: this.handleClick, color: active ? ButtonColor.primary : undefined, disabled: disabled }, renderer(page, type)));
    }
}
Pager.displayName = 'Pager';
